import Reveal from '@/components/base/Reveal';
import SectionTitle from '@/components/base/SectionTitle';
import { watchSteps } from '@/mocks/drama';

export default function GuideSection() {
  return (
    <section id="guide" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <Reveal>
          <SectionTitle
            eyebrow="追更指南"
            title="想一口气看完？先按这四步来"
            description="短剧最怕看得零碎、记不住伏笔。下面这套浏览路径，帮你用最少的重复、最短的时间，从第一集顺畅走到大结局。"
          />
        </Reveal>

        <div className="mt-10 grid gap-5 md:gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {watchSteps.map((item, index) => (
            <Reveal key={item.id} delay={index * 70}>
              <div className="relative h-full rounded-lg border border-background-200 bg-background-100 p-5">
                <span className="font-heading text-3xl font-black text-accent-300">{item.step}</span>
                <h3 className="mt-2 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 font-body text-sm leading-relaxed text-foreground-700">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-8 rounded-lg bg-primary-500 p-6 md:p-8">
            <div className="flex flex-col md:flex-row md:items-center gap-5 md:gap-8">
              <div className="flex-1">
                <h3 className="font-heading text-lg md:text-2xl font-bold text-background-50 dark:text-foreground-950">
                  全集与完整版导览已整理完毕
                </h3>
                <p className="mt-2 font-body text-sm md:text-base leading-relaxed text-background-100 dark:text-foreground-900">
                  从第 1 集到大结局共 18 集看点、四个篇章脉络与高能名场面，都已在页面内形成闭环，无需跳转即可完整浏览。
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-3 shrink-0">
                <a
                  href="#episodes"
                  className="flex items-center justify-center gap-2 rounded-md bg-accent-500 px-5 py-3 font-label text-sm font-medium text-accent-950 hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-play-list-2-line text-lg" aria-hidden="true" />
                  从头浏览全集
                </a>
                <a
                  href="#faq"
                  className="flex items-center justify-center gap-2 rounded-md border border-background-50/50 px-5 py-3 font-label text-sm font-medium text-background-50 dark:text-foreground-950 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-question-line text-lg" aria-hidden="true" />
                  查看常见问题
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}